export interface MetaCursor {
  component: string;
  data: any;
}
